var _rect, _rect2, _rect3, _text, _text2, _text3, _path, _path2, _rect4, _text4, _rect5, _rect6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEverafterEvents(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1200 750",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1200,
    height: 750,
    fill: "#3b1838"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 70,
    width: 1060,
    height: 610,
    rx: 26,
    fill: "#fff8fb"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 70,
    width: 1060,
    height: 82,
    rx: 26,
    fill: "#bd4c76"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 120,
    y: 122,
    fontFamily: "Arial",
    fontSize: 28,
    fontWeight: 700,
    fill: "#fff"
  }, "EVERAFTER EVENTS")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 120,
    y: 250,
    fontFamily: "Georgia",
    fontSize: 62,
    fontWeight: 700,
    fill: "#4d1d3d"
  }, "Make it unforgettable.")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 120,
    y: 300,
    fontFamily: "Arial",
    fontSize: 23,
    fill: "#8b6478"
  }, "Moments planned with warmth and precision.")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M900 260c42 70 96 105 0 250-96-145-42-180 0-250Z",
    fill: "#edb1c6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M900 300c-80 40-130 88-60 184 70-96 20-144 60-184ZM900 300c80 40 130 88 60 184-70-96-20-144-60-184Z",
    fill: "#bd4c76"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 420,
    width: 280,
    height: 64,
    rx: 32,
    fill: "#4d1d3d"
  })), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 183,
    y: 460,
    fontFamily: "Arial",
    fontSize: 20,
    fontWeight: 700,
    fill: "#fff"
  }, "Plan your moment")), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 545,
    width: 190,
    height: 55,
    rx: 12,
    fill: "#f3dbe5"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 335,
    y: 545,
    width: 190,
    height: 55,
    rx: 12,
    fill: "#f3dbe5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEverafterEvents);
export default __webpack_public_path__ + "static/media/everafter-events.6a2e2be48ca56f3d0286167295d2610d.svg";
export { ForwardRef as ReactComponent };